import { computed, inject } from '@angular/core';
import { TranslationService } from '@lib/i18n/data-access';
import { patchState, signalStore, withComputed, withMethods, withState } from '@ngrx/signals';

import { RegionsStore } from '../regions/regions.store';
import { RegionStoreData } from './aggregator-regions.store.interface';

const INITIAL_STATE: RegionStoreData = {
  _selectedRegionId: null,
};

export const AggregatorRegionsStore = signalStore(
  withState(INITIAL_STATE),

  withComputed(({ _selectedRegionId }, { aggregatorRegions } = inject(RegionsStore), translationService = inject(TranslationService)) => {
    const currentRegionId = computed(() => {
      const regions = aggregatorRegions();
      const selectedId = _selectedRegionId();

      if (regions.length && !selectedId) {
        return regions[0].id;
      }

      return selectedId;
    });

    return {
      currentRegionId,
      selectedRegionName: computed(() => {
        const selectedRegionDto = aggregatorRegions().find((region) => region.id === currentRegionId());

        return selectedRegionDto ? translationService.translate(`regions.${selectedRegionDto.continent}`) : '';
      }),
      regionsForSwitcher: computed(() =>
        aggregatorRegions().map((region) => ({
          value: region.id,
          text: translationService.translate(`regions.${region.continent}`),
        })),
      ),
      regionsOptions: computed(() =>
        aggregatorRegions().map((region) => ({
          value: region.id,
          text: translationService.translate(`regions.${region.continent}`),
          isDisabled: region.id === currentRegionId(),
        })),
      ),
    };
  }),

  withMethods((store) => ({
    setRegion(id: number): void {
      patchState(store, { _selectedRegionId: id });
    },
  })),
);
